import './clock';
import './modal';
import './form-utms';

// Styles
/* import '../sass/main.scss'; */


//Mobile Menu / Hamburger Icon Controls
jQuery( "#nav-icon").click(function() {
	if (jQuery(this).hasClass('closed')) {
	jQuery(this).removeClass('closed').addClass('open');
	jQuery( "#mobile-nav" ).removeClass('closed').addClass('open');
  jQuery( "#search-container" ).removeClass('open').addClass('closed');
  jQuery( ".search-button-icon" ).removeClass('open').addClass('closed');
} else if (jQuery(this).hasClass('open')) {
	jQuery(this).removeClass('open').addClass('closed');
	jQuery( "#mobile-nav" ).removeClass('open').addClass('closed');
} else {
	// nothing
}
});


// Search Panel
var mobileNavMax = 1024;

function getHeaderHeight() {
	var headerHeight;
	const mobileSiteHeader = document.getElementById('mobile-site-header');
	const masthead = document.getElementById('masthead');

	if(window.innerWidth <= mobileNavMax) {
		headerHeight = mobileSiteHeader?.offsetHeight || 0;
	} else {
		headerHeight = masthead?.offsetHeight || 0;
	}
	return headerHeight;
}

function setSearchTopPos() {
	var headerHeight = getHeaderHeight();
	var adminBarHeight = (jQuery('body').hasClass('admin-bar')) ?  document.getElementById('wpadminbar').offsetHeight : 0;

	if(window.innerWidth > mobileNavMax) {
		jQuery("#search-container.open").css('top', (headerHeight + adminBarHeight));
	} else {
		jQuery("#search-container.open").css('top', headerHeight);
	}

}


jQuery( ".search-button-icon").click(function(e) {
	e.preventDefault();

	if (jQuery(this).hasClass('closed')) {
		jQuery(this).removeClass('closed').addClass('open');
		jQuery( "#search-container" ).removeClass('closed').addClass('open');
		setSearchTopPos();
	  jQuery( "#mobile-nav" ).removeClass('open').addClass('closed');
	  jQuery( "#nav-icon" ).removeClass('open').addClass('closed');

	} else if (jQuery(this).hasClass('open')) {
		jQuery(this).removeClass('open').addClass('closed');
		jQuery( "#search-container" ).removeClass('open').addClass('closed').css('top', '0');
	} else {
		// nothing
	}
});


// Setting content top padding based on header headerHeight
function setSiteContentTopPad() {
	var headerHeight = getHeaderHeight();

	if(jQuery('body').hasClass('admin-bar') && window.innerWidth <= mobileNavMax) {
		/* jQuery('div.site-content').css('padding-top', (headerHeight - 46)); */
	} else {
		/* jQuery('div.site-content').css('padding-top', headerHeight); */
	}
}

setSiteContentTopPad();


// Positioning c7 cart over header icons - c7 only supports a single cart on a page, and because we have separate desktop and mobile navigation, the cart link has to be placed over top both

var waitForEl = function(selector, callback) {
	if ( jQuery(selector).length ) {
		callback();
	} else {
		setTimeout(function() {
			waitForEl(selector, callback);
		}, 100);
	}
};

function position_top_c7_cart_link() {
	waitForEl('#c7-cart a', function() {
		var cartLink = document.getElementById('c7-cart').getElementsByTagName('a')[0];
		const masthead = document.getElementById('masthead');
		var desktopHeaderHeight = masthead && masthead.offsetHeight;
		var desktopMenuHeight = masthead && masthead.querySelector('.menus').offsetHeight;
		const mobileSiteHeader = document.getElementById('mobile-site-header');
		var mobileHeaderHeight = mobileSiteHeader && mobileSiteHeader.offsetHeight;
		var mobileMenuHeight = mobileSiteHeader && mobileSiteHeader.querySelector('.menus').offsetHeight;
		var adminBarHeight = (jQuery('body').hasClass('admin-bar')) ?  document.getElementById('wpadminbar')?.offsetHeight : 0;


		if(window.innerWidth <= mobileNavMax) {
			cartLink.style.top = (mobileHeaderHeight - (mobileMenuHeight * .50)) + 'px';
		} else {
			cartLink.style.top = (desktopHeaderHeight - (desktopMenuHeight * .50)) + adminBarHeight + 'px';
		}

		// Also color cart icon if items in cart
		var cartItems = jQuery(".c7-cart__count").html();
		if(cartItems && cartItems > 0) {
			jQuery('li.cart-icon').addClass('items-in-cart');
		}

	});
}

position_top_c7_cart_link();

function offsetFooterNewsletterAnchor() {
	var headerHeight = getHeaderHeight();
	var adminBarHeight = (jQuery('body').hasClass('admin-bar')) ?  document.getElementById('wpadminbar').offsetHeight : 0;
	var footerNewsAnchor = jQuery("#footer-newsletter-anchor");

	if(window.innerWidth > mobileNavMax && footerNewsAnchor.length) {
		footerNewsAnchor.css('top', -(headerHeight + adminBarHeight));
	} else {
		footerNewsAnchor.css('top', -headerHeight);
	}
}

offsetFooterNewsletterAnchor();

var navResizeTimer;
jQuery(window).on('resize', function(e) {
    clearTimeout(navResizeTimer);
    navResizeTimer = setTimeout(function() {
        position_top_c7_cart_link();
				setSearchTopPos();
				setSiteContentTopPad();
				offsetFooterNewsletterAnchor();
    }, 250);
});
